export default __webpack_public_path__ + "static/media/pvilla2-3.272a6109.jpg";